interface ToastOptions {
    message?: string;
    duration?: number;
    customStyles?: Partial<CSSStyleDeclaration>;
    containerStyles?: Partial<CSSStyleDeclaration>;
    position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
    onShow?: ((toastElement: HTMLElement) => void) | null;
    onClose?: (() => void) | null;
    customAnimations?: {
        fadeIn?: Partial<CSSStyleDeclaration>;
        fadeOut?: Partial<CSSStyleDeclaration>;
    };
}

export function createToast({
    message = "This is a toast message!",
    duration = 3000,
    customStyles = {},
    containerStyles = {},
    position = "top-right",
    onShow = null,
    onClose = null,
    customAnimations = {
        fadeIn: { opacity: '1', transition: 'opacity 0.5s ease' },
        fadeOut: { opacity: '0', transition: 'opacity 0.5s ease' }
    }
}: ToastOptions = {}): void {
    // Check if the toast container exists to avoid recreating
    let toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.id = 'toast-container';
        toastContainer.style.position = 'fixed';
        toastContainer.style.zIndex = customStyles.zIndex || '9999';

        // Default positioning logic for the container
        switch (position) {
            case 'top-left':
                toastContainer.style.top = '20px';
                toastContainer.style.left = '20px';
                break;
            case 'top-right':
                toastContainer.style.top = '20px';
                toastContainer.style.right = '20px';
                break;
            case 'bottom-left':
                toastContainer.style.bottom = '20px';
                toastContainer.style.left = '20px';
                break;
            case 'bottom-right':
                toastContainer.style.bottom = '20px';
                toastContainer.style.right = '20px';
                break;
            default:
                toastContainer.style.bottom = '20px';
                toastContainer.style.right = '20px';
        }

        // Apply container styles only once
        Object.assign(toastContainer.style, containerStyles);
        document.body.appendChild(toastContainer);
    }

    // Create a new toast element
    const toast = document.createElement('div');
    toast.className = 'deitToast';  // Use .deitToast class instead of .toast
    toast.innerText = message;

    // Apply custom styles to the toast element
    const defaultToastStyles: Partial<CSSStyleDeclaration> = {
        minWidth: '250px',
        marginBottom: '10px',
        padding: '15px',
        borderRadius: '5px',
        color: '#fff',
        backgroundColor: '#333',
        fontSize: '16px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        opacity: '0',
        transition: 'opacity 0.5s ease',
    };

    // Merge default and custom styles
    const finalToastStyles = { ...defaultToastStyles, ...customStyles };
    Object.assign(toast.style, finalToastStyles);

    // Append to the container
    toastContainer.appendChild(toast);

    // Trigger custom onShow callback if provided
    if (onShow && typeof onShow === 'function') {
        onShow(toast);
    }

    // Custom fadeIn animation
    setTimeout(() => {
        if (customAnimations.fadeIn) {
            Object.assign(toast.style, customAnimations.fadeIn);
        }
    }, 100);

    // Remove the toast after the specified duration
    setTimeout(() => {
        // Custom fadeOut animation
        if (customAnimations.fadeOut) {
            Object.assign(toast.style, customAnimations.fadeOut);
        }

        // Trigger custom onClose callback if provided
        setTimeout(() => {
            toast.remove();
            if (onClose && typeof onClose === 'function') {
                onClose();
            }
        }, 500);
    }, duration);
}